// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface LocationDirectionArrowIconSignature {
  Element: SVGSVGElement;
}

export const LocationDirectionArrowIcon: TOC<LocationDirectionArrowIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 17.088L18.606 19.919C18.983 20.082 19.428 19.995 19.718 19.697C20.007 19.399 20.081 18.954 19.906 18.578L12.906 3.578C12.742 3.226 12.389 3 12 3C11.611 3 11.258 3.225 11.094 3.577L4.094 18.577C3.919 18.953 3.993 19.398 4.282 19.696C4.57 19.993 5.013 20.083 5.394 19.919L12 17.088ZM12.394 15.082C12.268 15.027 12.134 15 12 15C11.866 15 11.732 15.026 11.606 15.081L7.014 17.048L12 6.365L16.986 17.049L12.394 15.082Z"/>
</svg>
</template>;